import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Grid, Header, Segment, Label } from "semantic-ui-react";

import { changePassword } from "../../actions/password/change";
import SystemHeader from "../components/system_header";
import Button from "../components/button";
import "../../App.css";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: this.props.match.params.token,
    };

    this.isFormSubmitted = false;
  }

  onChange = () => {
    this.isFormSubmitted = true;
    this.props.changePassword({
      password: this.state.new_password,
      password_confirmation: this.state.confirm_password,
      reset_password_token: this.state.token,
    });
  };

  composeErrorMessages = () => {
    const messages = [];

    if (typeof this.props.error === "string") {
      messages.push("An error occurred while changing the password.");
    } else {
      Object.keys(this.props.error).forEach((error_type) => {
        if (error_type === "password") {
          messages.push("Password is too short (minimum is 6 characters)");
        } else if (error_type === "password_confirmation") {
          messages.push("Password confirmation doesn't match Password");
        } else if (error_type === "reset_password_token") {
          messages.push("Reset password link has expired!");
        }
      });
    }

    return messages;
  };

  render() {
    const isSuccessShown = this.isFormSubmitted && !this.props.pending && !this.props.changeFailure;
    const isInvalidShown = this.isFormSubmitted && !this.props.pending && this.props.changeFailure;
    const isFormShown = this.isFormSubmitted ? !isSuccessShown : true;
    const errorMessages = isInvalidShown ? this.composeErrorMessages() : [];

    return (
      <React.Fragment>
        <SystemHeader showMenu={false} showLoading={false} />
        <div className="change-password-form" style={{ marginTop: "3rem" }}>
          <Grid textAlign="center" style={{ height: "100%" }} verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              {isFormShown && (
                <div>
                  <Header as="h2" textAlign="center" className="theme-font-color">
                    Change your password
                  </Header>
                  <Form size="large">
                    <Segment padded>
                      <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder="New password (6 characters minimum)"
                        type="password"
                        onChange={(event) => this.setState({ new_password: event.target.value })}
                        value={this.state.new_password}
                      />
                      <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder="Confirm new password"
                        type="password"
                        onChange={(event) => this.setState({ confirm_password: event.target.value })}
                        value={this.state.confirm_password}
                      />
                      <Button loading={this.props.pending} fluid size="large" onClick={this.onChange} disabled={this.props.pending}>
                        Change password
                      </Button>
                    </Segment>
                  </Form>
                </div>
              )}
              {isSuccessShown && (
                <Header as="h4" textAlign="center" className="theme-font-color">
                  <p>Your password has been changed</p>
                  <Button href="/">
                    Login
                  </Button>
                </Header>
              )}
              {isInvalidShown && (
                <div>
                  <br />
                  <label className="alert alert-danger" style={{ marginTop: "20px" }}>
                    {errorMessages.map((item, i) => (
                      <p key={i}> {item}</p>
                    ))}
                  </label>
                </div>
              )}
            </Grid.Column>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pending: state.change_password.pending,
    changeFailure: state.change_password.changeFailure,
    error: state.change_password.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (details) => {
      dispatch(changePassword(details));
    },
  };
};

let ChangePasswordPage = connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
export default ChangePasswordPage;



// WEBPACK FOOTER //
// ./src/views/password/change.js